import transport_alt from './Content/images/transporter_logo.png'
import { API_LOGO_BASE_URL } from './env.config';
const FileUrl = API_LOGO_BASE_URL;

export const getInitials=(name)=>{
  if(!name)
  return 'T'
  let ini=name.split(' ')
  let initials=''
  if(ini.length>1)
  initials=ini[0].charAt(0)+ini[1].charAt(0)
  else if(ini.length==1)
  initials=ini[0].charAt(0)
  else if(ini.length==0)
  initials='T'
  return initials.toLocaleUpperCase()


}
export const ImportAll = r => {
  let imports = {};
  r.keys().map(item => (imports[item.replace('./', '')] = r(item)));
  return imports;
};
export const hasValue=(value)=>{
  
}

export const Images = ImportAll(
  require.context('./Content/images', false, /\.(png|jpe?g|svg)$/)
);

export const PrepareSequentialArray = count => {
  let array = [];

  if (!count || count < -1) return array;

  for (let i = 1; i <= count; i++) {
    array.push(i);
  }

  return array;
};

export const UpsertElementToArray = (
  array = [],
  newOrUpdatedElement,
  keyToCompareBy
) => {
  return array.some(
    e => e[keyToCompareBy] === newOrUpdatedElement[keyToCompareBy]
  )
    ? UpdateElementToArray(array, newOrUpdatedElement, keyToCompareBy)
    : array.concat(newOrUpdatedElement);
};

export const UpdateElementToArray = (array, updatedElement, keyToCompareBy) =>
  array.map(e =>
    e[keyToCompareBy] === updatedElement[keyToCompareBy] ? updatedElement : e
  );

export const ReplaceOrInsertValueForKeyInArrayElement = (
  array = [],
  key,
  newVal
) => {
  if (array.some(el => el[key])) {
    return array.map(el => {
      if (el[key]) {
        el[key] = newVal;
      }
      return el;
    });
  } else {
    const newArr = array.slice();
    newArr.push({ [key]: newVal });
    return newArr;
  }
};

export const scrollToEndofDiv = (childId, parentId = 'app-body') => {
  var div = document.getElementById(childId);
  const body = document.getElementById(parentId);
  if (div && body && body.scrollTo) {
    body.scrollTo({ top: div.scrollHeight, behavior: 'smooth' });
  }
};

export const findDuplicateInArray = (list, key) => {
  let duplicatedValue = false;
  list.forEach(element => {
    if (
      list.filter(
        t => t[key].trim().toLowerCase() === element[key].trim().toLowerCase()
      ).length > 1
    ) {
      duplicatedValue = element[key];
      return;
    }
  });
  return duplicatedValue;
};

export const getNewGuid = () => {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    var r = (Math.random() * 16) | 0,
      v = c == 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
};
export const generateReactSelectOptions = (opts = [], key, trimmed) =>
  opts.map(o =>
    trimmed
      ? { label: o[key], value: o[key] }
      : { ...o, label: o[key], value: o[key] }
  );
export const getImageSrc=(logo)=>{
    if(logo&&logo.length>1)
    return `${FileUrl}/${logo}`
    return transport_alt
}
export const imageFallBack = e => {
  e.target.src = transport_alt;
};